import type { RoomBookingDto } from '@hub-wifi/shared'
import { apiRequest } from './client'

export interface CreateMyBookingBody {
  roomId: string
  /** ISO 8601 with the building's offset. */
  startAt: string
  endAt: string
}

/**
 * `POST /api/my/bookings` — the same payload `BookingFormCore` and the room
 * browse page send, so Exchange sync, quota and conflict checks are unchanged.
 */
export function createMyBooking(body: CreateMyBookingBody, token: string): Promise<RoomBookingDto> {
  return apiRequest<RoomBookingDto>('/api/my/bookings', {
    method: 'POST',
    token,
    body: { roomId: body.roomId, startAt: body.startAt, endAt: body.endAt },
  })
}
